export const updateColor = (frameColor, jsonIndex = 0) => {
    return prevModelJson => {
        const updatedModelArray = [...prevModelJson]
        const updatedJson = {...updatedModelArray[jsonIndex]};
        updatedJson.color = frameColor
        updatedModelArray[jsonIndex] = updatedJson
        return updatedModelArray
    }
}